import { fetchStringDetails } from 'api/queries.api'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { SessionContext } from 'contexts/session'

/**
 * Will use params to load correct string status
 * @returns 5 second interval block status
 */
const useStringStatusDetailQuery = () => {
  const { stationCode, blockIndex, arrayId, stringID } = useParams()
  const { session, setSession } = useContext(SessionContext)

  return useQuery(
    ['String', stationCode, blockIndex, arrayId, stringID],
    () =>
      fetchStringDetails(
        stationCode,
        blockIndex,
        arrayId,
        stringID,
        session,
        setSession,
      ),
    { refetchInterval: 5000 },
  )
}

export default useStringStatusDetailQuery
